import { useFetchById } from '../reactQuery';
import { BANK_API } from '../../../constant/api_url';
import { Bank } from '../../../types/bank.types';

export const useBankById = (id: number | string) => useFetchById<Bank>(`${BANK_API}/${id}`, id);
